var cannotLoadAjax = "Can not process your request";
var innovaApiUrl = "https://dev.innova.com/api";//$("#InnovaApiUrl").val();
var innovaApiKey = "H/Fp0tLdQVwq/DwPWwBcH7Rzacrf+59K2Ko9cmxxe648ygmh9TT7vJrmyyVf9vRh";//$("#InnovaKey").val();

$(document).ready(function ($) {
  // Initialize InputMask
  $("#Year").inputmask("9999");
  $("#Phone").inputmask("999-999-9999");
  
  var captchaKey = $("#GoogleCaptchaKey").val();
  $("div.g-recaptcha").attr("data-sitekey", captchaKey);  
  
  initContactPage();
  $("#ProductCategoryId").change(function () {
    if ($("#ProductCategoryId").val() != "") {
      loadPartNumberByProductCatgory('');
    }               
    else {
      $("#PartNumber").html("<option value=''>Part Number</option>");
    }
    $("#PartNumber").focus();
  });
    
  //validateContactForm();
});


function loadPartNumberByProductCatgory(productId) {
  $.ajaxSetup({ cache: false });
  $('#ModalContentAjax').modal("show");
  
  var cateId = $("#ProductCategoryId").val();
  xhr = $.ajax(
      {
        type: "GET",
        url: innovaApiUrl + "/products/"+ cateId +"/partnumbers",
        crossOrigin: true,
        beforeSend: function (xhr) {
            xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
        },
        //dataType: "text/html",
        error: function (xhr, status, error) {
          
        },
        success: function (data) {
          var items = "<option value='' >Part Number</option>";
          $.each(data.partNumbers, function (i, product) {
            if (product.productId == productId) {
              items += "<option value='" + product.sku + "' selected='selected' >" + product.name + "</option>";
            }else{                    
              items += "<option value='" + product.sku + "'>" + product.name + "</option>";
            }
          });
          
          $("#PartNumber").html(items);
          $('#ModalContentAjax').modal("hide");
        }
      });
  /*
  $.getJSON(innovaApiUrl + "/products/"+ cateId+"/partnumbers/", function (data) {
    var items = "<option value='' >Part Number</option>";
    $.each(data.partNumbers, function (i, product) {
      if (product.productId == productId) {
        items += "<option value='" + product.productId + "' selected='selected' >" + product.name + "</option>";
      }else{                    
        items += "<option value='" + product.productId + "'>" + product.name + "</option>";
      }
    });
    $("#PartNumber").html(items);

    $('#ModalContentAjax').modal("hide");   

  });*/
  
}

  
function initContactPage(){
  $("#errorMessage").hide();
  
  xhr = $.ajax(
    {
      type: "GET",
      url: innovaApiUrl + "/products/categories",
      beforeSend: function (xhr) {
        xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
      },
      //dataType: "text/html",
      error: function (xhr, status, error) {
        alert(cannotLoadAjax);
      },
      success: function (result) {
        var items = "<option value='' >Product Category</option>";
        $.each(result, function (i, cate) {                               
          items += "<option value='" + cate.key + "'>" + cate.value + "</option>";            
        });
        $("#ProductCategoryId").html(items);

      }
    });
}


function submitContact() { 
  $("#errorMessage").hide();
  if(validateContactForm()){ 
	 $('#ModalContentAjax').modal("show");
        xhr = $.ajax({
            type: "POST",
            crossOrigin: true,
            url: innovaApiUrl + "/supports",
            data: $("#frmTechnicianContact").serialize(),
            beforeSend: function (xhr) {
                xhr.setRequestHeader('inn-api-auth-ticket', innovaApiKey);
            },
            error: function () {
              $('#ModalContentAjax').modal("hide");
              $("#searchCoverageBtn").prop('disabled', false);
              grecaptcha.reset(0);
              alert(cannotLoadAjax);
            },
            success: function (result) {
                $('#ModalContentAjax').modal("hide");
                if(result.message.success){
					window.location = "/pages/thankyou";
                }else{
                	$("#errorMessage").html(result.message.description);
    				$("#errorMessage").show();
                }
              	 grecaptcha.reset(0);
            }
        });   
  }
  
  //if (ValidateForm()) {
  //  $("#frmTechnicianContact").submit();
  //}
  return false;
}

function validateContactForm(){
  var isValid = checkRequiredFields('frmTechnicianContact');
  var capcharVal = $("#captchaText").val();
  var errorMsg = "";
  $("#errorMessage").hide();
  
  if(!isValid){
  	errorMsg = "The field highlighted in red is required and must be filled out.";
  }
  if(capcharVal != 1 ){
    if(errorMsg != "")
      errorMsg += "<br/>";
    
    errorMsg += "Invalid security code.";
  }
  
  if(!IsEmail()){
  	if(errorMsg != "")
      errorMsg += "<br/>";
    
    errorMsg += "Email format is invalid.";
  }
  
  if(!IsPhoneNumber()){
  	if(errorMsg != "")
      errorMsg += "<br/>";
    
    errorMsg += "Phone Number is invalid.";
  }
  
  if(errorMsg != ""){
  	$("#errorMessage").html(errorMsg);
    $("#errorMessage").show();
  }
  
  return (errorMsg == "");
}

var actCallback = function (response) {
  	/*var secretKey = "6Lc_YlsUAAAAAGPFWrWwmAhxIoedWb7pw57Zs4Or";
  	xhr = $.ajax({
      type: "POST",
      async:false,
      crossDomain:true,
      url: "https://www.google.com/recaptcha/api/siteverify",
      data: "secret="+ secretKey +"&response="+ response,
       headers: { "X-Requested-With":"XMLHttpRequest",
                        'Access-Control-Allow-Origin': 'https://www.google.com/recaptcha',
                        'Access-Control-Allow-Methods': 'POST, GET, OPTIONS'
                    },
      error: function () {
        $('#ModalContentAjax').modal("hide");
        alert(cannotLoadAjax);
      },
      success: function (result) {
        $('#ModalContentAjax').modal("hide");
        $("#captchaText").val("1");
        $('#re-captcha').remove();
      }
    });  
  
  	*/
      $("#captchaText").val("1");
      $('#re-captcha').remove();
    
  };
  var expCallback = function() {
     $("#captchaText").val("0");
    
     grecaptcha.reset(0);
     setTimeout(function(){
       grecaptcha.reset(0);
     }, 30000);
  };
 
  var onloadCallback = function () {
    var captchaKey = $("#GoogleCaptchaKey").val();
    var widget = grecaptcha.render(document.getElementById("re-captcha"), {
      'sitekey' : captchaKey,//"6Lc_YlsUAAAAAFNAWFPEc-cw-0EsvM4PBnOMDSHP", // Sitekey, Retrieving from reCaptcha
      'theme': "light",
      'callback' : actCallback,
      'expired-callback': expCallback,
    });
  }
  
  